import moment from 'moment';
import i18next from 'i18next';

export const utcToLocal = (utcDate, format) => {
  return moment.utc(utcDate).local().format(format);
};

export const PERMISSION_TYPES = Object.freeze({
  ROLE: 'role',
  PERMISSION: 'permission',
});

export const PERMISSIONS_LEVEL = Object.freeze({
  ORGANIZATION: 'organization',
  FACILITY: 'facility',
});

export const REFUND_TYPES = {
  REGULAR: 'regular',
  INSURANCE: 'insurance',
  BUSINESS: 'business',
};

export const ENTITY_TYPE = Object.freeze({
  INDIVIDUAL: 'Individual',
  BUSINESS: 'Business',
  UNKNOWN: 'Unknown',
});

export const REFUND_METHOD = Object.freeze({
  ACH: 7,
  CHECK: 5,
  GIFTCARD: 4,
  DONATION: 6,
  PAYPAL: 2,
  VENMO: 3,
  TRANSFER_BACK: 8,
  CANCEL: 9,
});

export const CHECK_TYPE = Object.freeze({
  E_CHECK: 'E-check',
  PHYSICAL_CHECK: 'Physical Check',
});

export const TRANSACTION_STATUSES = Object.freeze({
  PENDING: 'Pending',
  SENT_UNCASHED: 'Sent-uncashed',
  ACH_SENT: 'ACH-sent',
  SUCCESS: 'Success',
  ACH_RETURNED: 'ACH-returned',
  VOIDED: 'Voided',
  ERROR: 'Error',
  ACH_RETURN_PENDING_RETURN_TO_BANK: 'ach_return_pending_return_to_bank',
  ACH_RETURN_AVAILABLE_TO_RECLAIM: 'ach_return_available_to_reclaim',
});

export const SYSTEM_TAGS = Object.freeze({
  MANUAL_ENTRY: 'manual-entry',
  REFUND_FILE: 'refund-file',
});

export const APPROVAL_STATUS = Object.freeze({
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
});

export const REFUND_STATUSES = Object.freeze({
  UNCLAIMED: 'Unclaimed',
  REQUESTED: 'Requested',
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
  ESCHEATED: 'Escheated',
  EXCEPTION: 'Exception',
});

export const REFUND_SUB_STATUS = Object.freeze({
  EMAIL_SENT: 'Email Sent',
  TEXT_SENT: 'Text Sent',
  MAIL_SENT: 'Mail Sent',
  COMMUNICATION_UNDELIVERABLE: 'Communication Undeliverable',
  COMMUNICATION: 'Communication',
  COMMUNICATION_PENDING: 'Communication Pending',
  ESCHEATMENT_EMAIL_SENT: 'Escheatment Email Sent',
  ESCHEATMENT_PHYSICAL_MAIL_SENT: 'Escheatment Physical Mail Sent',
  ESCHEATMENT_CERTIFIED_MAIL_SENT: 'Escheatment Certified Mail Sent',
  ESCHEATMENT_NUAPA_CLIENT_REVIEW: 'Escheatment NUAPA Client Review',
  ESCHEATED_TO_STATE: 'Escheated to State',
  DORMANT_PENDING_ESCHEATMENT: 'Dormant Pending Escheatment',
  PAYEE_EXCEPTION: 'Payee Exception',
  ADDENDA_MISSING: 'Addenda Missing',
  PROCESSING_EXCEPTION: 'Processing Exception',
  TRANSFER_PENDING: 'Transfer Pending',
  TRANSFER_COMPLETE: 'Transfer Complete',
  TRANSFER_FAILED: 'Transfer Failed',
});
export const REFUND_FILE_TYPES = Object.freeze({
  PAYEE_FILE_ATTACHMENT: 'payee-file-attachment',
  INTERNAL_FILE_ATTACHMENT: 'internal-file-attachment',
});

export const REFUND_MODAL_TYPE = Object.freeze({
  CREATE: 'createPaymentForm',
  APPROVALS: 'approvalsPage',
  RESOLUTION_CENTER: 'resolutionCenter',
  REFUNDS_PAGE: 'refundsPage',
});

export const PAYMENT_METHODS = [
  { text: 'ACH', value: 7 },
  { text: 'Donation', value: 6 },
  { text: 'Check', value: 5 },
  { text: 'Gift Card', value: 4 },
  { text: 'PayPal', value: 2 },
  { text: 'Venmo', value: 3 },
];

export const ORGANIZATION_FEATURES = {
  showBusinessUnitsPage: 'showBusinessUnitsPage',
  showApprovalsPage: 'showApprovalsPage',
  showCreatePaymentPage: 'showCreatePaymentPage',
  showFacilityManagementPage: 'showFacilityManagementPage',
};

export const SSO_FEATURE_FLAG = 'sso';

export const openPdf = (url) => {
  window.open(url, '_blank');
};

export const checkOrganizationFeatures = (key) => {
  const organizationFeatures = JSON.parse(
    localStorage.getItem('organizationFeatures') || '{}',
  );
  return !!organizationFeatures?.[key];
};

export const isPathOpen = (path) => {
  return (
    path.includes('user/login') ||
    path.includes('user/facilitylogin') ||
    path.includes('user/activation')
  );
};

export default function isAllowedForFacility({
  parentKey,
  childKey = 'viewPage',
  permission = 'read',
  facilityId,
}) {
  const appState = JSON.parse(localStorage.getItem('appState'));
  const role = appState?.user?.role;

  if (role === 'admin') {
    return true;
  }

  if (!facilityId || !parentKey || !childKey || !permission) {
    return false;
  }

  const userPermissions = JSON.parse(localStorage.getItem('userPermissions'));

  if (!userPermissions) {
    window.location.href = '/user/facilitylogin';
    return;
  }
  const userFacilityPermissions =
    userPermissions?.find((p) => p.facility_id === +facilityId)?.permissions?.[
      parentKey
    ]?.[childKey] ?? [];

  return userFacilityPermissions.includes(permission);
}

export const getPaymentTypeTranslation = (refundType) => {
  switch (refundType) {
    case REFUND_TYPES.REGULAR:
      return i18next.t('approvals.paymentTypes.consumer');
    case REFUND_TYPES.BUSINESS:
      return i18next.t('approvals.paymentTypes.business');
    case REFUND_TYPES.INSURANCE:
      return i18next.t('approvals.paymentTypes.insurance');
    default:
      return refundType;
  }
};
